type InitDigioProps = {
  requestId: string, identifier: string, token?: string, callback: any
};
export function initDigio({
  requestId, identifier, token, callback,
}: InitDigioProps) {
  const digioOptions = {
    //  currently setting this to prod, later shift to env
    // environment: process.env.REACT_APP_DIGIO_ENV,
    environment: 'production',
    callback(response: any) {
      callback(response);
    },
    event_listener: () => {
    // Handle events here
    },
    is_iframe: false,
    theme: {
      primaryColor: '#963a72',
    },
  };
  // @ts-ignore
  const digioInstance = new window.Digio(digioOptions);
  digioInstance.init();
  if (token) {
    digioInstance.submit(requestId, identifier, token);
  }
}

export default { };
